export const REGISTER_DATA_BAG: 'OFFLINE_AVAILABILITY/REGISTER_DATA_BAG' = 'OFFLINE_AVAILABILITY/REGISTER_DATA_BAG';
export const REGISTER_OFFLINE_CALL: 'OFFLINE_AVAILABILITY/REGISTER_OFFLINE_CALL' =
	'OFFLINE_AVAILABILITY/REGISTER_OFFLINE_CALL';
export const RESET: 'OFFLINE_AVAILABILITY/RESET' = 'OFFLINE_AVAILABILITY/RESET';
